import { render, staticRenderFns } from "./AppError.vue?vue&type=template&id=2206de10&scoped=true"
import script from "./AppError.vue?vue&type=script&lang=js"
export * from "./AppError.vue?vue&type=script&lang=js"
import style0 from "./AppError.vue?vue&type=style&index=0&id=2206de10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206de10",
  null
  
)

export default component.exports